import React from 'react';
import Image, { ImageProps } from 'next/image';

type TNextImage<T extends boolean = false> = T extends true
  ? { useDefaultHTMLTag: true } & React.ImgHTMLAttributes<HTMLImageElement>
  : { useDefaultHTMLTag?: false } & ImageProps;

export default function NextImage<T extends boolean>(props: TNextImage<T>) {
  if ((props as any).useDefaultHTMLTag) {
    return <img {...(props as any)} />;
  }

  return <Image {...(props as any)} unoptimized />;
}
